import {
  Button,
  HeadingRegular,
  Modal,
  NavigationItem,
} from '@pensionbee/honeypot-ui';
import { useState } from 'react';
import { useThemedImageSource } from '@/domains/theme/useThemedImageSource';
import { RadioGroup } from '@/domains/shared/components/radioGroup/radioGroup';
import { Controller, useForm } from 'react-hook-form';
import { StageProps } from '../../config/StrongerNudgeConfig';

interface DeclinedAppointmentFormData {
  declineAppointmentReason: string;
}

interface DeclineAppointmentOptionProps {
  isConfirmationScreen?: boolean;
}

export const DeclineAppointmentOption = (
  props: DeclineAppointmentOptionProps & { onSubmit: StageProps['onSubmit'] },
) => {
  const { isConfirmationScreen, onSubmit } = props;
  const denyIcon = useThemedImageSource('spot-deny');
  const [isOpenDeclineAppointment, setIsOpenDeclineAppointment] =
    useState(false);
  const closeDeclineAppointment = () => setIsOpenDeclineAppointment(false);
  const openDeclineAppointment = () => setIsOpenDeclineAppointment(true);

  const handleDeclineAppointment = async (
    data: DeclinedAppointmentFormData,
  ) => {
    await onSubmit({
      [isConfirmationScreen
        ? 'guidanceConfirmationOption'
        : 'guidanceAppointmentChoice']: 'Decline Appointment',
      reasonForDeclining: data.declineAppointmentReason,
    });
    closeDeclineAppointment();
  };
  const { control, watch, handleSubmit } = useForm({
    defaultValues: {
      declineAppointmentReason: '',
    },
  });
  const watchedDeclinedAppointmentReason = watch('declineAppointmentReason');

  return (
    <>
      <NavigationItem
        handleClick={openDeclineAppointment}
        title="Decline appointment"
        copy="You'd like to opt out or have already received guidance or advice."
        src={denyIcon}
        imageHeight="48px"
      />
      <Modal
        isOpen={isOpenDeclineAppointment}
        handleClose={closeDeclineAppointment}
        variant="bottom"
      >
        <div className="flex h-full flex-col justify-between">
          <HeadingRegular className="mb-28">
            Declining appointment?
          </HeadingRegular>
          <form onSubmit={handleSubmit(handleDeclineAppointment)}>
            <div className="pb-28">
              <Controller
                control={control}
                name="declineAppointmentReason"
                render={({ field }) => (
                  <RadioGroup
                    value={field.value}
                    onChange={field.onChange}
                    label="Why are you declining the appointment?"
                    options={[
                      {
                        label: "I've already received guidance",
                        value: 'Guidance Received',
                        helperOnSelected:
                          'Note: You could benefit from receiving guidance again if your circumstances or the value of your pension savings have changed significantly.',
                      },
                      {
                        label: "I've already received regulated advice",
                        value: 'Advice Received',
                        helperOnSelected:
                          'Note: You could benefit from receiving guidance again if your circumstances or the value of your pension savings have changed significantly.',
                      },
                      {
                        label: 'I am not interested in guidance or advice',
                        value: 'Not Interested',
                      },
                    ]}
                  />
                )}
              />
            </div>
            <Button
              className="w-full"
              type="submit"
              disabled={!watchedDeclinedAppointmentReason}
            >
              Next
            </Button>
          </form>
        </div>
      </Modal>
    </>
  );
};
